import "./ProductsPage.css";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { db } from "../../firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

export default function ProductsPage() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  // ✅ FETCH PRODUCTS FROM FIRESTORE
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));

        const productArray = querySnapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data(),
        }));

        setProducts(productArray);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // ✅ DELETE PRODUCT FROM FIRESTORE
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "products", id));

      // Update UI after delete
      const updatedProducts = products.filter((p) => p.id !== id);
      setProducts(updatedProducts);

      alert("Product Deleted");
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  return (
    <section className="productsPage">
      <h1>Products Details</h1>
      <hr />

      <div className="tableWrapper">
        <table className="productsTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Price</th>
              <th>Old Price</th>
              <th>Category</th>
              <th>Image</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>

          <tbody>
            {products.map((v) => (
              <tr key={v.id}>
                <td>{v.name}</td>
                <td>{v.price}</td>
                <td>{v.oldprice}</td>
                <td>{v.category}</td>
                <td>
                  {v.images && v.images.length > 0 && (
                    <img src={v.images[0]} alt={v.name} width="60" />
                  )}
                </td>
                <td>
                  <button
                    className="edit"
                    onClick={() => navigate(`/admin/products/edit/${v.id}`)}
                  >
                    Edit
                  </button>
                </td>
                <td>
                  <button className="delete" onClick={() => handleDelete(v.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="add-product">
        <FaPlus
          className="plus"
          onClick={() => navigate("/admin/products/add")}
        />
      </div>
    </section>
  );
}
